import React, { useEffect, useState } from "react";
import { useUnit } from "effector-react";
import InternalStudyCoursesService from "@services/internal-study-courses-service";
import {
  $ProcedureTraining,
  FetchAllTrainingPrograms,
} from "@store/company/procedure-training-store";
import toast from "react-hot-toast";
import Dropzone from "@ui/dropzone/dropzone";
import {
  TextField,
  Autocomplete,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import clsx from "clsx";
import style from "@scss/modals/company/create-company.module.scss";
import useModal from "@modals/modal-hook";
import useStyles from "@ui/material-ui-styles";

// type ProgramsList = {
//   id: number;
//   title: string;
//   category: string;
// }

const EditInternalCourseModal = () => {
  const { close, modalComponent, modalData, open } = useModal();
  const { programs } = useUnit($ProcedureTraining);

  const [programsList, setProgramsList] = useState<any[]>([]);
  const [programId, setProgramId] = useState<number>(modalData.programId);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const classes = useStyles();

  const handleProgramIdChange = (event: any, value: any) => {
    if (value) setProgramId(value.id);
  };

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    const modalBtn = document.querySelector(
      "button.modal_btn"
    ) as HTMLButtonElement;
    modalBtn.disabled = true;

    const title = document.querySelector(
      'input[name="title"]'
    ) as HTMLInputElement;
    const sync = document.querySelector(
      'input[name="sync"]'
    ) as HTMLInputElement;

    const formData = new FormData();
    formData.append("title", title?.value);
    formData.append("programId", programId ? programId.toString() : "");
    formData.append("sync", sync.checked ? "1" : "0");

    if (uploadedFiles.length) {
      formData.append("thumbnail", uploadedFiles[0]);
    }

    return InternalStudyCoursesService.update(
      modalData.id,
      formData,
      (err, res) => {
        if (err || !res) {
          if (err?.response?.status === 422) {
            modalBtn.disabled = false;
          }
          toast.error(`Ошибка при обновлении курса "${modalData.title}"`);
        }

        close();
      }
    );
  };

  useEffect(() => {
    FetchAllTrainingPrograms({
      isIncludeChanges: false,
      isIncludeCompany: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (programs) {
      const programsList: any[] = [];
      programs.map((p) => {
        p.programs.map((e) => {
          programsList.push({
            id: e.id,
            title: e.title,
            category: p.title,
          });
        });
      });
      setProgramsList(programsList);
    }
  }, [programs, programId]);

  return (
    <div key={modalComponent.key} className={clsx(style.create_company_modal)}>
      <p className="modal_title">Редактировать курс "{modalData.title}"</p>
      <div className="underline" />
      <form className={`modal_content ${classes.root}`} onSubmit={handleSubmit}>
        <TextField
          name="title"
          label="Название"
          variant="filled"
          required
          defaultValue={modalData.title || ""}
          slotProps={{
            input: {
              autoComplete: "off",
            },
          }}
        />

        <Autocomplete
          fullWidth
          size="small"
          options={programsList}
          getOptionLabel={(option) => option.title}
          getOptionKey={(option) => option.id}
          groupBy={(option) => option.category}
          value={
            programsList.length
              ? programsList.find((e) => e.id === programId)
              : null
          }
          noOptionsText={"Нет совпадений"}
          onChange={handleProgramIdChange}
          slotProps={{
            listbox: {
              sx: {
                padding: "0",
              },
            },
            popper: {
              popperOptions: {
                placement: "bottom-start",
              },
              sx: {
                width: "auto !important",
                maxWidth: "30vw",
              },
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="filled"
              label="Программа обучения"
              placeholder="Введите значение"
            />
          )}
        />
        <FormControlLabel
          control={
            <Checkbox name="sync" defaultChecked={modalData.sync === 1} />
          }
          name="sync"
          label="Синхронизировать автоматически"
        />

        {/* //TODO Добавить изменение родительских / дочерних элементов, 1 этап - простое редактирование */}
        <Dropzone
          withPreviews
          maxFiles={1}
          files={uploadedFiles}
          onUpload={(files) => setUploadedFiles(files)}
          onDeleteFile={() => setUploadedFiles([])}
          accept="image/jpeg, image/png"
          type={"course"}
        />
        <button type="submit" className="modal_btn">
          {modalComponent.btnText}
        </button>
      </form>
    </div>
  );
};

export default EditInternalCourseModal;
